module.exports = __webpack_public_path__ + "static/tabmaster-7166d14135aef1f5a5e4cd89cd63156f.png";